/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-guest-booking-details .gm-ui-hover-effect{display:none!important}  app-guest-booking-details .gm-style .gm-style-iw-c{box-shadow:none;max-width:216px!important;max-height:-webkit-max-content!important;max-height:-moz-max-content!important;max-height:max-content!important;border-radius:0}  app-guest-booking-details .gm-style .gm-style-iw-t::after{content:none}  app-guest-booking-details .markerLabel,   app-mobile-guest-booking-details .markerLabel{font-size:14px;font-weight:600;color:#141414;font-family:\"Hind Madurai\",sans-serif}"];
export { styles as styles };
